const COMMON_FETCH_ALLERGENS = {
  START: 'START_COMMON_FETCH_ALLERGENS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_ALLERGENS',
  FAIL: 'FAIL_COMMON_FETCH_ALLERGENS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_ALLERGENS',
}

export default COMMON_FETCH_ALLERGENS
